import {
  Typo3SectionSpotHeadlessFeature,
  Typo3SectionSpotSanityAccomodation,
  Typo3SectionSpotSanityCulture,
  Typo3SectionSpotSanityEatDrink,
  Typo3SectionSpotSanityEventList,
  Typo3SectionSpotSanityFreetime,
  Typo3SectionSpotSanityNature,
  Typo3SectionSpotSanityPressroom,
  Typo3SectionSpotSanityService,
  Typo3SectionSpotSanityShopping,
  Typo3SectionSpotSanitySport,
  Typo3SectionSpotSanitySportServices,
  Typo3SectionSpotSanityStory,
  Typo3SectionSpotSanityTour
} from '@/types/typo3'
import { SectionSliderType } from '@/ui/Sections/SectionSlider/type'

const toSectionSlider = (
  section:
    | Typo3SectionSpotSanityEventList
    | Typo3SectionSpotSanityAccomodation
    | Typo3SectionSpotHeadlessFeature
    | Typo3SectionSpotSanityStory
    | Typo3SectionSpotSanityEatDrink
    | Typo3SectionSpotSanityShopping
    | Typo3SectionSpotSanityFreetime
    | Typo3SectionSpotSanityNature
    | Typo3SectionSpotSanityService
    | Typo3SectionSpotSanitySportServices
    | Typo3SectionSpotSanityCulture
    | Typo3SectionSpotSanitySport
    | Typo3SectionSpotSanityTour
    | Typo3SectionSpotSanityPressroom
) => {
  const { type } = section

  // Common section data
  let sectionData: SectionSliderType = {
    section: section,
    sectionHeaderData: {
      title: section?.content?.title,
      titleLayout: section?.content?.titleLayout,
      overline: section?.content?.overline
    }
  }

  if (type === 'spotsanity_story') {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item.contentTeaser?.title,
        chipContent: item.category,
        image: item.images?.[0],
        link: {
          href: item.link?.href,
          target: item.link?.target
        }
      }))
    }
  } else if (type === 'spotsanity_pressroom') {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item.contentTeaser?.title,
        image: item.images?.[0],
        chipContent: item.category,
        link: {
          href: item.link?.href,
          target: item.link?.target
        }
      }))
    }
  } else if (type === 'spotsanity_eatdrink') {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item?.title,
        chipContent: item?.category,
        image: item.images?.[0],
        link: {
          href: item?.slug
        }
      }))
    }
  } else if (type === 'spotsanity_tour') {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item?.title,
        image: item.images?.[0],
        link: {
          href: item?.link?.href
        },
        tourInfo: {
          distance: item?.distanceFormatted,
          duration: item?.durationFormatted,
          altitudeUphill: item?.maxAltitude,
          altitudeDownhill: item?.minAltitude,
          difficulty: item?.difficulty,
          difficultyLabel: item?.difficultyLabel,
          isStatusClosed: item?.isStatusClosed,
          isStatusOpen: item?.isStatusOpen
        }
      }))
    }
  } else if (type === 'spotsanity_accommodation') {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item?.title,
        chipContent: section?.content?.overline,
        image: item.images?.[0],
        link: {
          label: item?.title || 'Book now',
          href: item?.slug
        }
      }))
    }
  } else if (
    type === 'spotsanity_shopping' ||
    type === 'spotsanity_freetime' ||
    type === 'spotsanity_nature' ||
    type === 'spotsanity_service' ||
    type === 'spotsanity_sportservice' ||
    type === 'spotsanity_cultureandarchitecture' ||
    type === 'spotsanity_sportinfrastructure'
  ) {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item?.title,
        chipContent: section?.content?.overline,
        image: item.images?.[0],
        link: {
          label: item?.title || 'Book now',
          href: item?.slug,
          target: item?.link?.target
        }
      }))
    }
  } else {
    sectionData = {
      ...sectionData,
      items: section?.content?.items?.map((item) => ({
        title: item.title,
        chipContent: item.categories,
        image: item.images?.[0],
        link: {
          href: item.link?.href,
          target: item.link?.target || undefined
        }
      }))
    }
  }

  return sectionData
}

export default toSectionSlider
